<template>
  <div class="mt-1">
    <b-card>
      <b-overlay :show="loading" rounded="sm" no-fade>
        <b-row class="mb-1">
          <b-col
            cols="12"
            md="7"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <b-button
              variant="outline-primary"
              class="btn-icon"
              :to="{ name: 'settings-courses' }"
            >
              <i class="fa-solid fa-arrow-left"></i>
              <span class="ml-25">Back</span>
            </b-button>
            <h3 class="ml-1">Edit Course</h3>
          </b-col>
        </b-row>

        <b-form v-if="loaded" @submit.prevent="onSubmit">
          <b-row>
            <b-col cols="12">
              <!-- Course title - tek satır -->
              <b-row class="mb-2">
                <b-col cols="12">
                  <b-form-group
                    label="Course title"
                    label-for="title"
                    class="mb-0"
                  >
                    <b-form-input
                      id="title"
                      v-model.trim="form.title"
                      required
                    />
                  </b-form-group>
                </b-col>
              </b-row>

              <!-- Summary ve Aim yan yana -->
              <b-row class="mb-2">
                <b-col md="6">
                  <b-form-group
                    label="Summary"
                    label-for="summary"
                    class="mb-0"
                  >
                    <b-form-textarea
                      id="summary"
                      v-model="form.summary"
                      rows="3"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group label="Aim" label-for="aim" class="mb-0">
                    <b-form-textarea id="aim" v-model="form.aim" rows="3" />
                  </b-form-group>
                </b-col>
              </b-row>

              <!-- Learning outcomes - tek satır -->
              <b-row class="mb-2">
                <b-col cols="12">
                  <b-form-group
                    label="Learning outcomes"
                    label-for="learning_outcomes"
                    class="mb-0"
                  >
                    <div>
                      <b-input-group
                        v-for="(lo, idx) in form.learning_outcomes"
                        :key="idx"
                        class="mb-50"
                      >
                        <b-form-input
                          v-model="form.learning_outcomes[idx]"
                          placeholder="Outcome"
                        />
                        <b-input-group-append>
                          <b-button variant="danger" @click="removeOutcome(idx)"
                            ><i class="fa fa-times"
                          /></b-button>
                        </b-input-group-append>
                      </b-input-group>
                      <b-button
                        size="sm"
                        variant="outline-primary"
                        @click="addOutcome"
                        >+ Add outcome</b-button
                      >
                    </div>
                  </b-form-group>
                </b-col>
              </b-row>

              <!-- Application method ve Max participants yan yana -->
              <b-row class="mb-2">
                <b-col md="6">
                  <b-form-group
                    label="Application method"
                    label-for="application_method"
                    class="mb-0"
                  >
                    <v-select
                      :options="options.enums.application_methods"
                      v-model="form.default_application_method"
                      :reduce="(val) => val"
                      placeholder="Select method"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    label="Max participants"
                    label-for="max_participants"
                    class="mb-0"
                  >
                    <b-form-input
                      id="max_participants"
                      type="number"
                      min="1"
                      v-model.number="form.default_max_participants"
                    />
                  </b-form-group>
                </b-col>
              </b-row>

              <!-- Require manager approval -->
              <b-row class="mb-2">
                <b-col md="6">
                  <b-form-checkbox
                    v-model="form.require_manager_approval_by_default"
                    >Require manager approval</b-form-checkbox
                  >
                </b-col>
              </b-row>

              <hr />
              <h5>Target audience</h5>
              <b-row>
                <b-col md="4" class="mb-1">
                  <label>Roles</label>
                  <v-select
                    multiple
                    :options="options.roles"
                    label="name"
                    :reduce="(r) => r.id"
                    v-model="form.role_ids"
                  />
                </b-col>
                <b-col md="4" class="mb-1">
                  <label>Companies</label>
                  <v-select
                    multiple
                    :options="options.companies"
                    label="title"
                    :reduce="(c) => c.id"
                    v-model="form.company_ids"
                  />
                </b-col>
                <b-col md="4" class="mb-1">
                  <label>Working groups</label>
                  <v-select
                    multiple
                    :options="options.working_groups"
                    label="title"
                    :reduce="(w) => w.id"
                    v-model="form.working_group_ids"
                  />
                </b-col>
              </b-row>

              <hr />
              <!-- <h5>Delivery</h5>
              <b-row>
                <b-col md="6" class="mb-1">
                  <label>Trainer</label>
                  <div class="d-flex">
                    <v-select class="flex-grow-1" :options="options.trainers" label="name" :reduce="t=>t.id" v-model="form.trainer_id"/>
                    <b-button class="ml-50" variant="outline-primary" @click="showTrainerModal = true">New</b-button>
                    <b-button class="ml-50" variant="outline-secondary" :disabled="!form.trainer_id" @click="editTrainer()">Edit</b-button>
                  </div>
                </b-col>
                <b-col md="6" class="mb-1">
                  <label>Venue</label>
                  <div class="d-flex">
                    <v-select class="flex-grow-1" :options="options.venues" label="name" :reduce="v=>v.id" v-model="form.venue_id"/>
                    <b-button class="ml-50" variant="outline-primary" @click="showVenueModal = true">New</b-button>
                    <b-button class="ml-50" variant="outline-secondary" :disabled="!form.venue_id" @click="editVenue()">Edit</b-button>
                  </div>
                </b-col>
              </b-row> -->

              <b-row>
                <b-col md="6" class="mb-1">
                  <label>Status</label>
                  <b-form-checkbox v-model="form.is_active"
                    >Active</b-form-checkbox
                  >
                </b-col>
              </b-row>

              <div class="mt-2">
                <b-button type="submit" variant="primary">Update</b-button>
                <b-button
                  variant="outline-secondary"
                  class="ml-1"
                  :to="{ name: 'settings-courses' }"
                  >Cancel</b-button
                >
              </div>
            </b-col>
          </b-row>
        </b-form>

        <trainer-modal
          :show.sync="showTrainerModal"
          :edit-id="editTrainerId"
          @saved="reloadTrainerOptions"
        />
        <venue-modal
          :show.sync="showVenueModal"
          :edit-id="editVenueId"
          @saved="reloadVenueOptions"
        />
      </b-overlay>
    </b-card>
  </div>
</template>

<script>
import {
  BOverlay,
  BCard,
  BRow,
  BCol,
  BForm,
  BFormGroup,
  BFormInput,
  BFormTextarea,
  BFormCheckbox,
  BButton,
  BInputGroup,
  BInputGroupAppend,
} from "bootstrap-vue";
import store from "@/store";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { onUnmounted } from "@vue/composition-api";
import settingsStoreModule from "../settingsStoreModule";
import vSelect from "vue-select";
import TrainerModal from "./TrainerModal.vue";
import VenueModal from "./VenueModal.vue";

export default {
  components: {
    BOverlay,
    BCard,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BFormCheckbox,
    BButton,
    BInputGroup,
    BInputGroupAppend,
    vSelect,
    TrainerModal,
    VenueModal,
    ToastificationContent,
  },
  setup() {
    const MODULE = "settings";
    if (!store.hasModule(MODULE))
      store.registerModule(MODULE, settingsStoreModule);
    onUnmounted(() => {
      if (store.hasModule(MODULE)) store.unregisterModule(MODULE);
    });
  },
  data() {
    return {
      loading: false,
      loaded: false,
      options: {
        roles: [],
        companies: [],
        working_groups: [],
        trainers: [],
        venues: [],
        enums: { application_methods: [], venue_types: [] },
      },
      form: {
        id: null,
        title: "",
        summary: "",
        aim: "",
        learning_outcomes: [],
        default_max_participants: null,
        default_application_deadline: null,
        default_application_method: null,
        require_manager_approval_by_default: false,
        is_active: true,
        role_ids: [],
        company_ids: [],
        working_group_ids: [],
        trainer_id: null,
        venue_id: null,
      },
      showTrainerModal: false,
      editTrainerId: null,
      showVenueModal: false,
      editVenueId: null,
    };
  },
  created() {
    this.loadOptions();
    this.loadCourse();
  },
  methods: {
    loadOptions() {
      store
        .dispatch("settings/fetchCourseOptions")
        .then((res) => {
          this.options = res.data;
        })
        .catch(() => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Failed to load options",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        });
    },
    loadCourse() {
      this.loading = true;
      const id = this.$route.params.id;
      store
        .dispatch("settings/getCourseById", { id })
        .then((res) => {
          const c = res.data;
          const wgs = c.working_groups || c.workingGroups || [];
          this.form = {
            ...this.form,
            ...c,
            role_ids: (c.roles || []).map((r) => r.id),
            company_ids: (c.companies || []).map((r) => r.id),
            working_group_ids: wgs.map((r) => r.id),
          };
          this.loaded = true;
        })
        .catch(() => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Failed to load course",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
          this.$router.push({ name: "settings-courses" });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    reloadTrainerOptions() {
      this.loadOptions();
      this.showTrainerModal = false;
      this.editTrainerId = null;
    },
    reloadVenueOptions() {
      this.loadOptions();
      this.showVenueModal = false;
      this.editVenueId = null;
    },
    addOutcome() {
      this.form.learning_outcomes.push("");
    },
    removeOutcome(i) {
      this.form.learning_outcomes.splice(i, 1);
    },
    editTrainer() {
      this.editTrainerId = this.form.trainer_id;
      this.showTrainerModal = true;
    },
    editVenue() {
      this.editVenueId = this.form.venue_id;
      this.showVenueModal = true;
    },
    onSubmit() {
      this.loading = true;
      const payload = { ...this.form };
      const id = this.$route.params.id;
      store
        .dispatch("settings/updateCourse", { id, data: payload })
        .then(() => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Course updated",
              icon: "ThumbsUpIcon",
              variant: "success",
            },
          });
          this.$router.push({ name: "settings-courses" });
        })
        .catch(() => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Update failed",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
